export enum NotificationLinkTitle {
  application = 'Open Application Details',
  agent = 'Open Agent Details',
  ticket = 'Open Ticket',
  lead = 'Open Lead',
  subAgent = 'Open Sub Agent',
  disputes = 'Open Disputes',
}
